/**
 * @generated SignedSource<<44525442e19df36f0b375d8cc3e61a43>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DevAiFlowSessionsStatus = "COMPLETED" | "FAILED" | "IN_PROGRESS" | "PAUSED" | "PENDING" | "%future added value";
export type useCompleteFlowMutation$variables = {
  id: string;
};
export type useCompleteFlowMutation$data = {
  readonly devai_flowSessionComplete: {
    readonly id: string;
    readonly sessionARI: string;
    readonly status: DevAiFlowSessionsStatus | null;
  } | null;
};
export type useCompleteFlowMutation = {
  response: useCompleteFlowMutation$data;
  variables: useCompleteFlowMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "DevAiFlowSession",
    "kind": "LinkedField",
    "name": "devai_flowSessionComplete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sessionARI",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCompleteFlowMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCompleteFlowMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cc140d5e728fc3dcb4ddeb2c539a132d",
    "id": null,
    "metadata": {},
    "name": "useCompleteFlowMutation",
    "operationKind": "mutation",
    "text": "mutation useCompleteFlowMutation(\n  $id: ID!\n) {\n  devai_flowSessionComplete(id: $id) @optIn(to: \"DevAiFlowSessionComplete\") {\n    id\n    sessionARI\n    status\n  }\n}\n"
  }
};
})();

(node as any).hash = "fd278c01fdd08d6ca6228a142f57d4e2";

export default node;
